export function relationshipDisplayedTitle(relationshipTitle, opposingPartyName) {
    return relationshipTitle !== opposingPartyName ? relationshipTitle : null;
}
